export const environment = {
	production: true,
	hmr: false,
	name: 'prod',
	rest: '',
	volumenes: 'http://volumenes.rs.com.ar/', // Más adelante serán el mismo proyecto. Por ahora, por más que sean iguales,
	saiku: 'http://volumenes.rs.com.ar/', // las mantenemos separadas por dev.
	conducelo: 'https://conducelo.com',
	scraper: 'https://scraper.rs.com.ar',
	comparador: '/ComparadorApi',
	firebase: {
		apiKey: 'AIzaSyBZgA6AEiGZQVx_1dEqBsCR5it7esTbtYM',
		authDomain: 'nyvus-drive.firebaseapp.com',
		databaseURL: 'https://nyvus-drive.firebaseio.com',
		projectId: 'nyvus-drive',
		storageBucket: 'nyvus-drive.appspot.com',
		messagingSenderId: '113622707281',
		appId: '1:113622707281:web:667b9cab2e2ef647d11c70',
	},
};
